<template>
<div data-component="ExpansionPanel.vue" class="text-center mobile-introduction">
	<div class="rounded-lg shadow-elevation-y-2px bg-white p-3" @click="toggleDetailsVisible(0)">
		<div class="flex justify-between items-center font-bold text-left">
			<div class="flex items-center">
				<BaseIcon :name="icon.name" size="1.5" class="mr-3" :class="icon.className" :set="icon.set"/>
				<div class="text-base font-bold">
					{{ title }}
				</div>
			</div>

			<BaseIcon
				name="chevron-down"
				size="0.5"
				class="cursor-pointer"
				:class="{ 'rotate-180': isDetailsVisible[0] }"
			/>
		</div>
		<div v-if="isDetailsVisible[0]" class="mt-4">
			<slot/>
		</div>
	</div>
</div>
</template>

<script lang="ts">

export default {
	name: 'ExpansionPanel',
	props: {
		title: {
			type: String,
			required: true,
		},
		contentItems: {
			type: Array,
			default: () => [],
		},
		icon: {
			type: Object,
			default: () => ({ name: '', className: [], set: 'base' }),
		},
	},
	data() {
		return {
			isDetailsVisible: [false, false],
		};
	},
	methods: {
		toggleDetailsVisible(index: number) {
			this.isDetailsVisible[index] = !this.isDetailsVisible[index];
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
